
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "madefor3286454608",
      {"classes":{"root":"madefor3286454608__root","madefor":"madefor3286454608__madefor"},"vars":{"wix-font-stack":"--wix-font-stack","wix-font-weight-regular":"--wix-font-weight-regular","wix-font-weight-medium":"--wix-font-weight-medium","wix-font-weight-bold":"--wix-font-weight-bold","wix-font-weight-xbold":"--wix-font-weight-xbold"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  